import Vue from 'vue'
import axios from '@/plugins/axios'

/**
 * Busca dados de status de SMS do dia
 * @returns {Array} Array com dados dos status do dia
 */
export const getStatusDataToday = async ({ commit }) => {
  commit('setLoading', true)
  
  try {
    const { data } = await axios.get('report-graphics/sms-status/today')

    if (data?.statusData) {
      commit('setStatusData', data.statusData)
      return data.statusData
    }

    return []
  } catch (err) {
    console.error('Erro ao buscar dados de status do dia:', err)
    Vue.prototype.$toast.error('Erro ao carregar dados do gráfico')
    return []
  } finally {
    commit('setLoading', false)
  }
}

